<div class="modalChat vc-modal">
  <div class="vc-text-l modalChat__item modalChat__item--intro">
    <span class="modalChat__item__title" i18n="@@CHAT.MODAL.MORE_ACTIONS">More actions</span>
    <button aria-label="close modal" class="modalChat__item__btn" (click)="dialogRef.close()">
      <vc-sprite-icons name="cross-x"></vc-sprite-icons>
    </button>
  </div>

  <ul class="modalChat__list modalChat__list--thisUser">
    <li class="vc-text-s modalChat__item modalChat__item--profil">
      <span
        class="modalChat__item__pic"
        [style.backgroundImage]="'url(' + getImage(data?.receiver?.picture.path) + ')'"
      ></span>
      <p class="vc-text-m">{{ data?.receiver?.username | titlecase }}</p>
    </li>

    <ng-container *ngIf="!isBlocked; else unblock">
      <li class="vc-text-s modalChat__item modalChat__item--warn" (click)="confirmBlockUser()">
        <vc-sprite-icons class="modalChat__item__svg" name="lock"></vc-sprite-icons>
        <span i18n="@@CHAT.MODAL.CTA.BLOCK_USER">Block user</span>
      </li>
    </ng-container>
    <ng-template #unblock>
      <li class="vc-text-s modalChat__item" (click)="confirmBlockUser()">
        <vc-sprite-icons class="modalChat__item__svg" name="unlock"></vc-sprite-icons>
        <span i18n="@@CHAT.MODAL.CTA.UNBLOCK_USER">Unblock user</span>
      </li>
    </ng-template>
  </ul>

  <ul class="modalChat__list">
    <li>
      <a
        class="vc-text-s modalChat__item"
        href="https://faq.vestiairecollective.com/hc/en-us/categories/360001871457-NEW-Buyer-Seller-chat"
        i18n-href="@@CHAT.MODAL.CTA.READ_FAQ_LINK"
        i18n="@@CHAT.MODAL.CTA.READ_FAQ"
      >
        <vc-sprite-icons class="modalChat__item__svg" name="question-mark"></vc-sprite-icons>
        <span>Read FAQ</span>
      </a>
    </li>
    <li (click)="onModalReportClick()">
      <a
        class="vc-text-s modalChat__item modalChat__item--warn"
        [href]="data?.urlFormReport"
        i18n="@@CHAT.MODAL.CTA.REPORT"
      >
        <vc-sprite-icons class="modalChat__item__svg" name="issue"></vc-sprite-icons>
        <span>Report an issue</span>
      </a>
    </li>
  </ul>
</div>
